import { describeError, toast } from '@vivicta/ui';

/* A failed request nothing awaited never reaches a page's error boundary, so it
 * used to fail silently. This catches what every page missed and says so. */

/** The same failure repeated by polling shows once, not once per poll. */
const REPEAT_WINDOW_MS = 10_000;

/* Cancelling on purpose (closing a page, stopping Create) isn't a failure. */
const isCancellation = (reason: unknown) =>
  reason instanceof Error &&
  (reason.name === 'AbortError' || reason.name === 'CreationCancelledError');

export const reportUnhandledErrors = () => {
  const shownAt = new Map<string, number>();

  globalThis.addEventListener('unhandledrejection', event => {
    if (isCancellation(event.reason)) return;
    const message = describeError(event.reason);
    const now = Date.now();
    if (now - (shownAt.get(message) ?? 0) < REPEAT_WINDOW_MS) return;
    shownAt.set(message, now);
    toast.error('Something went wrong', {
      description: `${message.replace(/\.?$/, '.')} Reload the page, and if it happens again, tell the portal team.`,
    });
  });
};
